module.exports = __webpack_public_path__ + "img/d0f37fb.svg";